import { makeStyles } from "@material-ui/core";
import _ from "lodash";
import * as React from "react";
import { Fragment, useState } from "react";
import {
  Button,
  Confirm,
  useRefresh,
  useNotify,
  useUnselectAll,
  useDataProvider,
} from "react-admin";

interface IBulkActionProps {
  selectedIds: number[];
  label: string;
  action: string;
  basePath: string;
  filterValues: any;
  resource: string;
}

const getActionColor = (action: string) => {
  switch (action) {
    case "ready":
      return "#4caf50";
    case "cancelled":
      return "#f44336";
    case "started":
      return "#1976d2";
    case "ended":
      return "#7c4dff";
  }
};

const useStyles = makeStyles({
  actionColor: {
    backgroundColor: (props: any) => `${getActionColor(props.action)}`,
    color: "#FFF",
  },
});

const BulkActionButton = ({
  selectedIds,
  label,
  action,
  resource,
  ...props
}: IBulkActionProps) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const provider = useDataProvider();

  const classes = useStyles({ action });

  const handleClick = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleConfirm = () => {
    setLoading(true);

    if (action === "delete") {
      Promise.all(
        selectedIds.map((idToDelete: number) => {
          return provider
            .delete(resource, {
              id: idToDelete,
              previousData: null,
            })
            .then((res: any) => {
              return { success: true, id: idToDelete };
            })
            .catch((error) => {
              return { success: false, id: idToDelete };
            });
        })
      ).then((result: any) => {
        console.log("DELETE", { result });
        if (_.find(result, { success: false })) {
          notify("Some item(s) cannot be deleted");
        } else {
          notify("Item(s) deleted");
          unselectAll(resource);
        }
        setLoading(false);
        refresh();
      });
    } else {
      provider
        .customUpdateMany(resource, {
          data: {
            assignmentIds: selectedIds,
            status: action,
          },
        })
        .then((res: any) => {
          setLoading(false);

          console.log("SUCCESS", res);
          refresh();
          notify("Item(s) updated");
          unselectAll(resource);
        })
        .catch((error: any) => {
          setLoading(false);

          console.log("ERR", error);
          notify("Error: item not updated", "warning");
        });
    }

    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        label={label}
        onClick={handleClick}
        className={classes.actionColor}
      />
      <Confirm
        isOpen={open}
        loading={loading}
        title={
          action === "delete" ? "Delete item(s)" : `Set item(s) to be ${action}`
        }
        content={`Are you sure you want to ${label.toLowerCase()} for these items?`}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </Fragment>
  );
};

export default BulkActionButton;
